// The campaign editor's queue of approved take-overs (`pendingGroupResolutions`,
// keyed by holder id) rebuilt from what the backend keeps on the campaign row
// between saves (`pendingTakeovers`). One helper, with no imports, so the
// loaded form and the adaptor's "unchanged" baseline serialize the exact same
// object and the form doesn't read as dirty on load.
export const queueFromStoredTakeovers = (stored) =>
  Object.fromEntries(
    (Array.isArray(stored) ? stored : [])
      .filter((t) => t?.targetCampaignId && Array.isArray(t.products) && t.products.length)
      .map((t) => [
        t.targetCampaignId,
        { direction: 'takeOver', byCampaign: { id: t.targetCampaignId }, products: t.products, count: t.products.length },
      ])
  );
